import { render } from "./MembershipForm.vue?vue&type=template&id=b9e96e2c&scoped=true&ts=true"
import script from "./MembershipForm.vue?vue&type=script&lang=ts"
export * from "./MembershipForm.vue?vue&type=script&lang=ts"

import "./MembershipForm.vue?vue&type=style&index=0&id=b9e96e2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e96e2c"]])

export default __exports__